import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OrderFulfillmentReducedFragmentDoc } from '../fragments/orderFulfillmentReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrderFulfillmentsQueryVariables = Types.Exact<{
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
  filter: Types.OrderFulfillmentFilter;
}>;


export type GetOrderFulfillmentsQuery = { __typename?: 'Query', getOrderFulfillments: { __typename?: 'OrderFulfillmentPaginatedResult', total: number, order_fulfillments: Array<{ __typename?: 'OrderFulfillment', id: string, status: Types.OrderFulfillmentStatus, is_billable: boolean, event_id: string, type: string, timestamp: string, authorized_signer_id?: string | null, authorized_signer_name?: string | null, created_by_id: string, created_by_name: string, event: { __typename?: 'Event', id: string, name?: string | null, is_deleted: boolean }, assets: Array<{ __typename?: 'TrackableItem', id: string }>, container_stations: Array<{ __typename?: 'OrderFulfillmentContainerStation', id: string, name: string, returned_sealed: boolean, containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }> }>, single_containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, item_location: { __typename?: 'ItemLocation', id: string, name: string }, event_account: { __typename?: 'EventAccount', id: string, name?: string | null, is_billable: boolean, is_deleted: boolean } }> } };


export const GetOrderFulfillmentsDocument = gql`
    query GetOrderFulfillments($skip: Int!, $take: Int!, $filter: OrderFulfillmentFilter!) {
  getOrderFulfillments(skip: $skip, take: $take, filter: $filter) {
    total
    order_fulfillments {
      ...OrderFulfillmentReduced
    }
  }
}
    ${OrderFulfillmentReducedFragmentDoc}`;

/**
 * __useGetOrderFulfillmentsQuery__
 *
 * To run a query within a React component, call `useGetOrderFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderFulfillmentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrderFulfillmentsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderFulfillmentsQuery, GetOrderFulfillmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderFulfillmentsQuery, GetOrderFulfillmentsQueryVariables>(GetOrderFulfillmentsDocument, options);
      }
export function useGetOrderFulfillmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderFulfillmentsQuery, GetOrderFulfillmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderFulfillmentsQuery, GetOrderFulfillmentsQueryVariables>(GetOrderFulfillmentsDocument, options);
        }
export type GetOrderFulfillmentsQueryHookResult = ReturnType<typeof useGetOrderFulfillmentsQuery>;
export type GetOrderFulfillmentsLazyQueryHookResult = ReturnType<typeof useGetOrderFulfillmentsLazyQuery>;
export type GetOrderFulfillmentsQueryResult = Apollo.QueryResult<GetOrderFulfillmentsQuery, GetOrderFulfillmentsQueryVariables>;